import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { StateContext } from './state-context'
import withLocation from '../../common/with-location'

const fontSize = new Map([
  [1, '14px'],
  [2, '13px'],
  [3, '12px'],
])

const navTabStep = new Map([
  [1, '0'],
  [2, '10px'],
  [3, '25px'],
])

const fontColor = new Map([
  [1, '#000'],
  [2, '#172931'],
  [3, '#6A7980'],
])

const RightMenuWrapper = styled.div`
  overflow-x: hidden;
  width: 210px;
  max-height: calc(100vh - 230px);
  position: fixed;
  right: calc((100% - 1250px) / 2);
  top: 160px;
  z-index: 5;
  overflow-y: scroll;
  background: #fff;
  > p {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 5px 0;
  }
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.1);
  }
`

const SectionWrapper = styled.section``

const SectionBlock = styled.section``

export const NavLink = styled(Link)`
  display: block;
  user-select: none;
  font-size: ${({ rank }) => fontSize.get(rank) || '12px'};
  padding-left: ${({ rank }) => navTabStep.get(rank) || '80px'};
  padding-right: 15px;
  background: #fff;
  color: ${({ active, rank }) => (active ? '#f2063f' : fontColor.get(rank) || '#2e2e2e')};
  border-left: ${({ active }) => (active ? '3px' : '2px')} solid
    ${({ active }) => (active ? '#f2063f' : '#e6e6e6')};
  text-decoration: none;
  min-height: 23px;
  :hover {
    color: #f2063f;
  }
`

export const RightMenu = withLocation(({ Location, baseName }) => {
  const { state, dispatch } = useContext(StateContext)
  const handleLink = (e, id) => {
    e.preventDefault()
    const top = document.getElementById(id)?.offsetTop || 0
    document.documentElement.scrollTop = top - 130
    if (window) {
      window.history.pushState('', `${baseName}`, `${Location.origin}${Location.pathname}#${id}`)
      dispatch({
        type: 'setHash',
        payload: id,
      })
    }
  }

  useEffect(() => {
    dispatch({
      type: 'setHash',
      payload: Location.hash.slice(1),
    })
    if (window) {
      const top = document.getElementById(Location.hash.slice(1))?.offsetTop || 0
      document.documentElement.scrollTop = top - 130
    }
  }, [dispatch, Location.hash])

  return (
    <RightMenuWrapper>
      <p>{process.env.GATSBY_LOCALE === 'zh' ? '本页目录' : 'Directories'}</p>
      <SectionWrapper>
        {state.rightMenuList.map((item, i) => (
          <SectionBlock key={i}>
            {item.groupIndex === state.groupIndex && (
              <>
                {item.title && (
                  <NavLink
                    rank={2}
                    to={`/${baseName}/api-doc/#${item.id}`}
                    active={state.currentHash === item.id ? 1 : 0}
                    onClick={(e) => handleLink(e, item.id)}
                  >
                    {item.title}
                  </NavLink>
                )}
                <section>
                  {item.children &&
                    item.children.map((child) => (
                      <NavLink
                        rank={3}
                        key={child.id}
                        to={`/${baseName}/api-doc/#${child.id}`}
                        active={state.currentHash === child.id ? 1 : 0}
                        onClick={(e) => handleLink(e, child.id)}
                      >
                        {child.title}
                      </NavLink>
                    ))}
                </section>
              </>
            )}
          </SectionBlock>
        ))}
      </SectionWrapper>
    </RightMenuWrapper>
  )
})
